import axios from 'axios';
export default axios.create({
    baseURL: `https://b.smartbraingo.com/api`,
    //  baseURL: `http://127.0.0.1:8000/api`,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization':'Bearer '+localStorage.getItem("token")??""
    }
});